/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Charges from './Charges/index'
import DueDate from './DueDate/index'
import Notes from './Notes/index'
import PaymentAccount from 'DesignSystem/PaymentAccount/index'
import PaymentAccountFilter from 'DesignSystem/PaymentAccount/PaymentAccountFilter/index'
import PaymentAccountSelect from 'DesignSystem/PaymentAccount/PaymentAccountSelect/index'
import React from 'react'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2Claim from 'DesignSystem/Svgs/Tysiav2Claim/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/ActiveAction/CreateProcedureReceivables/Content/Content/Claim/Content",
  onChange
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let patientIdValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'id',
})
let claimPaymentAccountChangeData = fromData.useDataChange({ viewPath,
context: 'claim',
path: 'payment_account',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--btlr-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-5-Z1Yf8zk': dtColorsNeutral200,'--pt-6-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-7-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-8-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-9-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--g-10-Z1Yf8zk': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--mb-11-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2Claim
  viewPath={`${viewPath}/Tysiav2Claim`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Claim"
 weight="medium"
/>
</div>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-10-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mb-11-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<PaymentAccount
  viewPath={`${viewPath}/PaymentAccount`}
 data="patient.id"
 patientId={patientIdValueData}
 data="claim.payment_account"
 onChange={claimPaymentAccountChangeData}
 includePersonPayors={false}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 marginTop={0}
 text="Payor"
/>
<PaymentAccountFilter
{...childProps}
  viewPath={`${viewPath}/PaymentAccountFilter`}
 labelExisting="Existing"
 labelNew="New"
/>
<PaymentAccountSelect
{...childProps}
  viewPath={`${viewPath}/PaymentAccountSelect`}
/>
</React.Fragment>
)}
</PaymentAccount>
<DueDate
  viewPath={`${viewPath}/DueDate`}
/>
</div>
<Notes
  viewPath={`${viewPath}/Notes`}
/>
<Charges
  viewPath={`${viewPath}/Charges`}
/>
</div>
{children}
</React.Fragment>)
}